// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#dashboardsetting-box .boxes .checkbox-country {
    margin-bottom: 6px;
    font-size: .9rem !important;
}
#dashboardsetting-box .boxes .title {
    font-size: 1rem !important;
    font-weight: bold;
    margin-bottom: 10px;
}
#dashboardsetting-box .boxes {
    border: 2px solid #ddd;
    padding: 10px 10px;
    margin-left: 0px;
    margin-right: 0px;
}
#dashboardsetting-box {
    display: block;
    min-width: 700px;
}
.content-employeeinfo input[type=text]:not(.browser-default), 
.content-employeeinfo input[type=date]:not(.browser-default),
.content-employeeinfo input[type=time]:not(.browser-default),
.content-personaldata input[type=text]:not(.browser-default), 
.content-personaldata input[type=date]:not(.browser-default),
.content-personaldata input[type=time]:not(.browser-default) {
    height: 2.4rem;
    line-height: 2.4rem;
}
.content-employeeinfo .filter-input-field.select .search,
.content-personaldata .filter-input-field.select .search {
    height: auto;
    line-height: auto;
}
.content-employeeinfo .dropdown-content li>span,
.content-personaldata .dropdown-content li>span {
    line-height: 16px !important;
}
.content-employeeinfo ul.dropdown-content,
.content-personaldata ul.dropdown-content {
    left: 5px !important;
    top: 38px !important;
}
.content-employeeinfo .input-field,
.content-personaldata .input-field {
    margin-top: 6px;
}
.content-employeeinfo .filter-input-field .label,
.content-personaldata .filter-input-field .label {
    text-align: left;
    display: block;
    padding: 0 0.75rem;
    color: #5a5a5a;
}
.content-employeeinfo .filter-input-field.select .col,
.content-personaldata .filter-input-field.select .col {
    border: 0px !important;
    border-radius: 0px;
    margin-top: 6px;
}
.content-employeeinfo .select-wrapper input.select-dropdown,
.content-personaldata .select-wrapper input.select-dropdown {
    border: 1px solid #9e9e9e6e !important;
    padding-left: 8px;
    height: 2.4rem;
    line-height: 2.4rem;
}
.content-employeeinfo .filter-input-field,
.content-personaldata .filter-input-field {
    padding: 5px 0;
}
.content-employeeinfo .filter-input-field .input-field.col,
.content-personaldata .filter-input-field .input-field.col {
    background-color: transparent;
    border-radius: 0;
}
.content-employeeinfo .filter-input-field.disable .input-field.col,
.content-personaldata .filter-input-field.disable .input-field.col {
    background-color: #f4f4f4;
    border-radius: 6px;
}
.content-employeeinfo.row,
.content-personaldata.row {
    margin-bottom: 0px;
}
#content-employeeinfo-row-1.row,
#content-personaldata-row-1.row {
    margin-top: 18px;
}
/*.content-employeeinfo.row:not(#content-employeeinfo-row-1) {
    display: grid;
    grid-template-columns: auto auto auto;
    grid-gap: 10px;
    margin-bottom: 0px;
}*/
#employeeinfo-box {
    margin-left: 20px;
    margin-right: 10px;
}
#btn-upload-photo {
    border-radius: 18px;
    position: absolute;
    top: 29px;
    right: 0px;
}
#upload-photo-name {
    font-size: 12px;
    font-style: italic;
    display: block;
}
#content-employeeinfo-inner-upload-photo,
#content-personaldata-inner-upload-photo,
#content-personaldata-inner-photo {
    position: relative;
    margin-left: 8%;
    margin-right: 8%;
    height: 110px;
    margin-top: 15px;
}
#content-employeeinfo-upload-photo .image-detail,
#content-personaldata-upload-photo .image-detail,
#content-personaldata-photo .image-detail {
    padding-top: 24px;
    margin-left: 120px;
    margin-right: 90px;
}
#content-employeeinfo-upload-photo .image-circle i,
#content-personaldata-upload-photo .image-circle i,
#content-personaldata-photo .image-circle i {
    margin-left: 0px;
    margin-top: 24px;
}
#content-employeeinfo-upload-photo .image-circle,
#content-personaldata-upload-photo .image-circle,
#content-personaldata-photo .image-circle{
    left: 0;
    margin-left: 0
}
#content-employeeinfo-upload-photo,
#content-personaldata-upload-photo,
#content-personaldata-photo {
    border: 2px solid #ddd;
    padding-top: 5px;
    padding-bottom: 7px;
}
#adminconsole-menu-list a:hover:not(.disable){
    color: #25867d;
    font-weight: 600;
}
#adminconsole-menu-list a.active{
    margin-bottom: 5px;
    color: #25867d;
    font-weight: 600;
}
#adminconsole-menu-list a {
    margin-bottom: 5px;
    color: #26a69a;
    font-weight: normal;
}
#adminconsole-menu-list {
    width: 100%;
    text-align: left;
    padding-left: 25px;
    padding-right: 25px;
    font-weight: 500;
    background-color: #fff;
    color: #26a69a;
    border: 2px solid #26a69a !important;
    line-height: normal;
    box-shadow: none;
    min-width: 235px;
    margin: 0 !important;
}
#adminconsole {
    margin-bottom: 0 !important;
    border-bottom: 0 !important;
}
#adminconsole-menu-list.disable {
    background: #e6e6e6;
    border: 2px solid #b4b0b0 !important;
    color: #9d9c9c !important;
}
#adminconsole-menu-list a.disable {
    color: #9d9c9c !important;
}
.btn-menu-left:hover:not(.disable) {
    background: #156059 !important;
    color: #fff !important;
}
.btn-menu-left.active{
    color: #fff;
    background-color: #25867d;
}
.btn-menu-left {
    width: 100%;
    margin-bottom: 15px;
    text-align: left;
    padding-left: 25px;
    padding-right: 25px;
    font-weight: 500;
    background-color: #fff;
    color: #26a69a;
    border: 2px solid #26a69a !important;
    line-height: normal;
    box-shadow: none;
    min-width: 235px;
    margin-bottom: 16px !important;
}
.collection-item.disable {
    background: #e6e6e6;
    border: 2px solid #b4b0b0 !important;
    color: #9d9c9c !important;
}
#left-content {
    padding: 0;
    border: 0;
    margin: 0;
}
#left-content .btn-menu-left {
    min-width: 0;
}
#left-content #adminconsole-menu-list {
    min-width: 0;
}
#addmember-content {
    margin-top: 20px;
}

/*--------------------------*/

.th-remove [type="checkbox"]+span:not(.lever) {
   font-size: 13px !important;
    color: #000 !important;
}

#recip-box-form-add .select-wrapper input.select-dropdown:disabled {
    background-color: #c9c6c6;
    color: #fff;
}

.report-items {
    margin-bottom: 10px;
}
.checkbox-report-group-item {
    position: absolute;
    top: -72px;
    left: 20px;
    z-index: 1;
}
[type="checkbox"].filled-in:not(:checked)+span:before {
    display: none;
}
[type="checkbox"].filled-in:checked+span:after {
    top: 0;
    width: 20px;
    height: 20px;
    border: 2px solid #26a69a;
    background-color: #26a69a;
    z-index: 0;
    /*display: none;*/
}
.report-item [type="checkbox"].filled-in:disabled:checked+span:not(.lever):after {
    background-color: #26a69a;
    border-color: #0e6b62;
}
/* .report-item [type="checkbox"].filled-in:disabled:not(:checked)+span:not(.lever):after {
    border-color: #5a5a5a;
    background-color: #fff;
} */
#dashboardaccess-box .collap-rep-group-item .collapsible-body {
    padding: 2em 0.3rem;
}
#dashboardaccess-box .collap-item .collapsible-body .row {
    margin-bottom: 0px;
    position: relative;
}

/* Checkbox dashboard report */
.checkbox-country-report-item{
    margin: 2px;
    float: left;
}
.checkbox-country-report-item label {
    float: left;
    cursor: pointer;
}
.checkbox-country-report-item label span {
    text-align: center;
    padding: 3px 1em;
    display: block;
}
.checkbox-country-report-item label input {
    position: absolute;
    display: none;
    color: #26a69a !important;
}
.checkbox-country-report-item label input + span{
    border: 1px solid #26a69a;
    background-color: #fff;
    color: #26a69a;
    font-weight: 500;
    overflow: hidden;
    border-radius: 12px;
}
.checkbox-country-report-item input:checked + span {
    border: 1px solid #26a69a;
    background-color: #26a69a;
    color: #fff;
}
.checkbox-country-report-item.active input + span{
    border: 1px solid #26a69a;
    background-color: #26a69a;
    color: #fff;
}
.checkbox-country-report-item input:hover + span {
    border: 1px solid #156059;
    background-color: #156059;
    color: #fff;
}
.checkbox-country-report-item.disable input + span{
    border: 1px solid #26a69a;
    background-color: #fff;
    color: #26a69a;
    /* background-color: #26a69a;
    border-color: #0e6b62; */
}
.checkbox-country-report-item.disable.active input + span{
    /* border: 1px solid #9e9e9e;
    background-color: #9e9e9e; */
    color: #fff;
    background-color: #26a69a;
    border-color: #0e6b62;
}
/* End checkbox dashboard report */

.collap-item h6 {
    font-weight: 600;
}
.group-item, .destination-item, .salesoffice-item {
    padding: 3px 5px !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/profile/style.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,2BAA2B;AAC/B;AACA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;;;;;;IAMI,cAAc;IACd,mBAAmB;AACvB;AACA;;IAEI,YAAY;IACZ,iBAAiB;AACrB;AACA;;IAEI,4BAA4B;AAChC;AACA;;IAEI,oBAAoB;IACpB,oBAAoB;AACxB;AACA;;IAEI,eAAe;AACnB;AACA;;IAEI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,cAAc;AAClB;AACA;;IAEI,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;AACA;;IAEI,sCAAsC;IACtC,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;AACA;;IAEI,cAAc;AAClB;AACA;;IAEI,6BAA6B;IAC7B,gBAAgB;AACpB;AACA;;IAEI,yBAAyB;IACzB,kBAAkB;AACtB;AACA;;IAEI,kBAAkB;AACtB;AACA;;IAEI,gBAAgB;AACpB;AACA;;;;;EAKE;AACF;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;AACA;;;IAGI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,gBAAgB;AACpB;AACA;;;IAGI,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;;;IAGI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;;;IAGI,OAAO;IACP;AACJ;AACA;;;IAGI,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,oCAAoC;IACpC,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,2BAA2B;IAC3B,2BAA2B;AAC/B;AACA;IACI,mBAAmB;IACnB,oCAAoC;IACpC,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,8BAA8B;IAC9B,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,oCAAoC;IACpC,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,8BAA8B;AAClC;AACA;IACI,mBAAmB;IACnB,oCAAoC;IACpC,yBAAyB;AAC7B;AACA;IACI,UAAU;IACV,SAAS;IACT,SAAS;AACb;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;;AAEA,6BAA6B;;AAE7B;GACG,0BAA0B;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,UAAU;AACd;AACA;IACI,aAAa;AACjB;AACA;IACI,MAAM;IACN,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,UAAU;IACV,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;;;GAGG;AACH;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,8BAA8B;AAC9B;IACI,WAAW;IACX,WAAW;AACf;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd;4BACwB;AAC5B;AACA;IACI;gCAC4B;IAC5B,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;AACA,kCAAkC;;AAElC;IACI,gBAAgB;AACpB;AACA;IACI,2BAA2B;AAC/B","sourcesContent":["#dashboardsetting-box .boxes .checkbox-country {\r\n    margin-bottom: 6px;\r\n    font-size: .9rem !important;\r\n}\r\n#dashboardsetting-box .boxes .title {\r\n    font-size: 1rem !important;\r\n    font-weight: bold;\r\n    margin-bottom: 10px;\r\n}\r\n#dashboardsetting-box .boxes {\r\n    border: 2px solid #ddd;\r\n    padding: 10px 10px;\r\n    margin-left: 0px;\r\n    margin-right: 0px;\r\n}\r\n#dashboardsetting-box {\r\n    display: block;\r\n    min-width: 700px;\r\n}\r\n.content-employeeinfo input[type=text]:not(.browser-default), \r\n.content-employeeinfo input[type=date]:not(.browser-default),\r\n.content-employeeinfo input[type=time]:not(.browser-default),\r\n.content-personaldata input[type=text]:not(.browser-default), \r\n.content-personaldata input[type=date]:not(.browser-default),\r\n.content-personaldata input[type=time]:not(.browser-default) {\r\n    height: 2.4rem;\r\n    line-height: 2.4rem;\r\n}\r\n.content-employeeinfo .filter-input-field.select .search,\r\n.content-personaldata .filter-input-field.select .search {\r\n    height: auto;\r\n    line-height: auto;\r\n}\r\n.content-employeeinfo .dropdown-content li>span,\r\n.content-personaldata .dropdown-content li>span {\r\n    line-height: 16px !important;\r\n}\r\n.content-employeeinfo ul.dropdown-content,\r\n.content-personaldata ul.dropdown-content {\r\n    left: 5px !important;\r\n    top: 38px !important;\r\n}\r\n.content-employeeinfo .input-field,\r\n.content-personaldata .input-field {\r\n    margin-top: 6px;\r\n}\r\n.content-employeeinfo .filter-input-field .label,\r\n.content-personaldata .filter-input-field .label {\r\n    text-align: left;\r\n    display: block;\r\n    padding: 0 0.75rem;\r\n    color: #5a5a5a;\r\n}\r\n.content-employeeinfo .filter-input-field.select .col,\r\n.content-personaldata .filter-input-field.select .col {\r\n    border: 0px !important;\r\n    border-radius: 0px;\r\n    margin-top: 6px;\r\n}\r\n.content-employeeinfo .select-wrapper input.select-dropdown,\r\n.content-personaldata .select-wrapper input.select-dropdown {\r\n    border: 1px solid #9e9e9e6e !important;\r\n    padding-left: 8px;\r\n    height: 2.4rem;\r\n    line-height: 2.4rem;\r\n}\r\n.content-employeeinfo .filter-input-field,\r\n.content-personaldata .filter-input-field {\r\n    padding: 5px 0;\r\n}\r\n.content-employeeinfo .filter-input-field .input-field.col,\r\n.content-personaldata .filter-input-field .input-field.col {\r\n    background-color: transparent;\r\n    border-radius: 0;\r\n}\r\n.content-employeeinfo .filter-input-field.disable .input-field.col,\r\n.content-personaldata .filter-input-field.disable .input-field.col {\r\n    background-color: #f4f4f4;\r\n    border-radius: 6px;\r\n}\r\n.content-employeeinfo.row,\r\n.content-personaldata.row {\r\n    margin-bottom: 0px;\r\n}\r\n#content-employeeinfo-row-1.row,\r\n#content-personaldata-row-1.row {\r\n    margin-top: 18px;\r\n}\r\n/*.content-employeeinfo.row:not(#content-employeeinfo-row-1) {\r\n    display: grid;\r\n    grid-template-columns: auto auto auto;\r\n    grid-gap: 10px;\r\n    margin-bottom: 0px;\r\n}*/\r\n#employeeinfo-box {\r\n    margin-left: 20px;\r\n    margin-right: 10px;\r\n}\r\n#btn-upload-photo {\r\n    border-radius: 18px;\r\n    position: absolute;\r\n    top: 29px;\r\n    right: 0px;\r\n}\r\n#upload-photo-name {\r\n    font-size: 12px;\r\n    font-style: italic;\r\n    display: block;\r\n}\r\n#content-employeeinfo-inner-upload-photo,\r\n#content-personaldata-inner-upload-photo,\r\n#content-personaldata-inner-photo {\r\n    position: relative;\r\n    margin-left: 8%;\r\n    margin-right: 8%;\r\n    height: 110px;\r\n    margin-top: 15px;\r\n}\r\n#content-employeeinfo-upload-photo .image-detail,\r\n#content-personaldata-upload-photo .image-detail,\r\n#content-personaldata-photo .image-detail {\r\n    padding-top: 24px;\r\n    margin-left: 120px;\r\n    margin-right: 90px;\r\n}\r\n#content-employeeinfo-upload-photo .image-circle i,\r\n#content-personaldata-upload-photo .image-circle i,\r\n#content-personaldata-photo .image-circle i {\r\n    margin-left: 0px;\r\n    margin-top: 24px;\r\n}\r\n#content-employeeinfo-upload-photo .image-circle,\r\n#content-personaldata-upload-photo .image-circle,\r\n#content-personaldata-photo .image-circle{\r\n    left: 0;\r\n    margin-left: 0\r\n}\r\n#content-employeeinfo-upload-photo,\r\n#content-personaldata-upload-photo,\r\n#content-personaldata-photo {\r\n    border: 2px solid #ddd;\r\n    padding-top: 5px;\r\n    padding-bottom: 7px;\r\n}\r\n#adminconsole-menu-list a:hover:not(.disable){\r\n    color: #25867d;\r\n    font-weight: 600;\r\n}\r\n#adminconsole-menu-list a.active{\r\n    margin-bottom: 5px;\r\n    color: #25867d;\r\n    font-weight: 600;\r\n}\r\n#adminconsole-menu-list a {\r\n    margin-bottom: 5px;\r\n    color: #26a69a;\r\n    font-weight: normal;\r\n}\r\n#adminconsole-menu-list {\r\n    width: 100%;\r\n    text-align: left;\r\n    padding-left: 25px;\r\n    padding-right: 25px;\r\n    font-weight: 500;\r\n    background-color: #fff;\r\n    color: #26a69a;\r\n    border: 2px solid #26a69a !important;\r\n    line-height: normal;\r\n    box-shadow: none;\r\n    min-width: 235px;\r\n    margin: 0 !important;\r\n}\r\n#adminconsole {\r\n    margin-bottom: 0 !important;\r\n    border-bottom: 0 !important;\r\n}\r\n#adminconsole-menu-list.disable {\r\n    background: #e6e6e6;\r\n    border: 2px solid #b4b0b0 !important;\r\n    color: #9d9c9c !important;\r\n}\r\n#adminconsole-menu-list a.disable {\r\n    color: #9d9c9c !important;\r\n}\r\n.btn-menu-left:hover:not(.disable) {\r\n    background: #156059 !important;\r\n    color: #fff !important;\r\n}\r\n.btn-menu-left.active{\r\n    color: #fff;\r\n    background-color: #25867d;\r\n}\r\n.btn-menu-left {\r\n    width: 100%;\r\n    margin-bottom: 15px;\r\n    text-align: left;\r\n    padding-left: 25px;\r\n    padding-right: 25px;\r\n    font-weight: 500;\r\n    background-color: #fff;\r\n    color: #26a69a;\r\n    border: 2px solid #26a69a !important;\r\n    line-height: normal;\r\n    box-shadow: none;\r\n    min-width: 235px;\r\n    margin-bottom: 16px !important;\r\n}\r\n.collection-item.disable {\r\n    background: #e6e6e6;\r\n    border: 2px solid #b4b0b0 !important;\r\n    color: #9d9c9c !important;\r\n}\r\n#left-content {\n    padding: 0;\n    border: 0;\n    margin: 0;\n}\n#left-content .btn-menu-left {\n    min-width: 0;\n}\n#left-content #adminconsole-menu-list {\n    min-width: 0;\n}\n#addmember-content {\n    margin-top: 20px;\n}\n\r\n/*--------------------------*/\r\n\r\n.th-remove [type=\"checkbox\"]+span:not(.lever) {\r\n   font-size: 13px !important;\r\n    color: #000 !important;\r\n}\r\n\r\n#recip-box-form-add .select-wrapper input.select-dropdown:disabled {\r\n    background-color: #c9c6c6;\r\n    color: #fff;\r\n}\r\n\r\n.report-items {\r\n    margin-bottom: 10px;\r\n}\r\n.checkbox-report-group-item {\r\n    position: absolute;\r\n    top: -72px;\r\n    left: 20px;\r\n    z-index: 1;\r\n}\r\n[type=\"checkbox\"].filled-in:not(:checked)+span:before {\r\n    display: none;\r\n}\r\n[type=\"checkbox\"].filled-in:checked+span:after {\r\n    top: 0;\r\n    width: 20px;\r\n    height: 20px;\r\n    border: 2px solid #26a69a;\r\n    background-color: #26a69a;\r\n    z-index: 0;\r\n    /*display: none;*/\r\n}\r\n.report-item [type=\"checkbox\"].filled-in:disabled:checked+span:not(.lever):after {\r\n    background-color: #26a69a;\r\n    border-color: #0e6b62;\r\n}\r\n/* .report-item [type=\"checkbox\"].filled-in:disabled:not(:checked)+span:not(.lever):after {\r\n    border-color: #5a5a5a;\r\n    background-color: #fff;\r\n} */\r\n#dashboardaccess-box .collap-rep-group-item .collapsible-body {\r\n    padding: 2em 0.3rem;\r\n}\r\n#dashboardaccess-box .collap-item .collapsible-body .row {\r\n    margin-bottom: 0px;\r\n    position: relative;\r\n}\r\n\r\n/* Checkbox dashboard report */\r\n.checkbox-country-report-item{\r\n    margin: 2px;\r\n    float: left;\r\n}\r\n.checkbox-country-report-item label {\r\n    float: left;\r\n    cursor: pointer;\r\n}\r\n.checkbox-country-report-item label span {\r\n    text-align: center;\r\n    padding: 3px 1em;\r\n    display: block;\r\n}\r\n.checkbox-country-report-item label input {\r\n    position: absolute;\r\n    display: none;\r\n    color: #26a69a !important;\r\n}\r\n.checkbox-country-report-item label input + span{\r\n    border: 1px solid #26a69a;\r\n    background-color: #fff;\r\n    color: #26a69a;\r\n    font-weight: 500;\r\n    overflow: hidden;\r\n    border-radius: 12px;\r\n}\r\n.checkbox-country-report-item input:checked + span {\r\n    border: 1px solid #26a69a;\r\n    background-color: #26a69a;\r\n    color: #fff;\r\n}\r\n.checkbox-country-report-item.active input + span{\r\n    border: 1px solid #26a69a;\r\n    background-color: #26a69a;\r\n    color: #fff;\r\n}\r\n.checkbox-country-report-item input:hover + span {\r\n    border: 1px solid #156059;\r\n    background-color: #156059;\r\n    color: #fff;\r\n}\r\n.checkbox-country-report-item.disable input + span{\r\n    border: 1px solid #26a69a;\r\n    background-color: #fff;\r\n    color: #26a69a;\r\n    /* background-color: #26a69a;\r\n    border-color: #0e6b62; */\r\n}\r\n.checkbox-country-report-item.disable.active input + span{\r\n    /* border: 1px solid #9e9e9e;\r\n    background-color: #9e9e9e; */\r\n    color: #fff;\r\n    background-color: #26a69a;\r\n    border-color: #0e6b62;\r\n}\r\n/* End checkbox dashboard report */\r\n\r\n.collap-item h6 {\r\n    font-weight: 600;\r\n}\r\n.group-item, .destination-item, .salesoffice-item {\r\n    padding: 3px 5px !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
